import { render } from "./BoardDirectory.vue?vue&type=template&id=3d4e0af5&scoped=true"
import script from "./BoardDirectory.vue?vue&type=script&lang=js"
export * from "./BoardDirectory.vue?vue&type=script&lang=js"

import "./BoardDirectory.vue?vue&type=style&index=0&id=3d4e0af5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4e0af5"]])

export default __exports__